const bg = document.getElementById("parallax-bg");
window.addEventListener("scroll", ()=>{
    const yPos = window.scrollY * 0.5;
    bg.style.transform = `translateY(${yPos}px)`;
}, {
    passive: true
});

//# sourceMappingURL=en.ac42cfd8.js.map
